import { useMount } from 'react-use'
import { Page } from '@/hooks/use-authorization/constants'
import useDefaultPage from '@/hooks/use-authorization/use-default-page'
import { goToPage } from '@/utils/routes/go-to-page'
import { toVoidFunction } from '@/utils/to-void-function'

type UseCheckPageAvailable = (available: boolean, fallbackPage?: Page) => void

/**
 * @description: Redirect to the fallback page if the current page is not available
 * @usage useCheckPageAvailable(withFeature(FeatureFlag.CompetitiveAnalysis))
 * @param available Determine if the current page has permission
 * @param fallbackPage Page to redirect to if the current page is not available, defaults to useDefaultPage
 */
const useCheckPageAvailable: UseCheckPageAvailable = (
  available,
  fallbackPage,
) => {
  const defaultPage = useDefaultPage()

  useMount(() => {
    toVoidFunction(async (): Promise<void> => {
      if (available) {
        return
      }

      await goToPage(fallbackPage ?? defaultPage)
    })()
  })
}

export default useCheckPageAvailable
